import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Select, Form, Input, Modal } from 'antd';
import { formItemLayout, tailFormItemLayout } from '../../common_functions';
import * as userActions from '../../redux/actions/userActions';
import { useDispatch } from 'react-redux';
import { ReloadOutlined, SearchOutlined, CloseOutlined } from '@ant-design/icons';

const PrintAdvanceSearchModal = ({ visible, onClose, onFinish, formRef, resetFilters }) => {
  // const formRef = useRef(null);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [conceptPortfolios, setConceptPortfolios] = useState([]);

  //Get collection data
  useEffect(() => {
    const getDefaultData = async () => {
      try {
        setLoading(true);

        await getConcetualPortfolio();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getDefaultData();
  }, []);

  const getConcetualPortfolio = async () => {
    const { data: portfolio } = await dispatch(
      userActions.getItems('portfolio', {
        fields: ['id', 'name'],
        limit: '-1',
        sort: 'name',
        filters: { type: { _eq: process.env.conceptual_work_id } },
      })
    );
    setConceptPortfolios(portfolio);
  };

  return (
    <>
      <Modal title="Advanced Print Search" open={visible} onCancel={onClose} footer={false} width={900} confirmLoading={loading}>
        <Form ref={formRef} layout="vertical" onFinish={onFinish} {...formItemLayout} initialValues={{ layout: tailFormItemLayout }}>
          <Row gutter={24}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="object_name" label="Common Title">
                <Input placeholder="Enter Common Title" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="acquisition" label="Acquisition ID">
                <Input placeholder="Enter Acquisition ID" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="portfolio_add_number" label="Portfolio">
                <Select placeholder="Select Portfolio" optionFilterProp="children" showSearch allowClear>
                  {conceptPortfolios.map(col => {
                    return <Select.Option key={col.id} value={col.id}>{col.name}</Select.Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item style={{ float: 'right' }}>
                <Button
                  style={{
                    marginRight: '10px',
                    height: '42px',
                    marginTop: '28px',
                  }}
                  size="small"
                  danger
                  onClick={resetFilters}
                  icon={<ReloadOutlined />}
                >
                  Reset
                </Button>

                <Button
                  type="primary"
                  size="small"
                  htmlType="submit"
                  style={{
                    marginTop: '28px',
                    height: '42px',
                  }}
                  icon={<SearchOutlined />}
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
export default PrintAdvanceSearchModal;
